import { useEffect, useState } from "react"
import { Cell, LabelList, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts"
import CustomizedLabel from "./PieChartComponents/CustomizedLabel"
import CustomTooltip from "./PieChartComponents/CustomTooltip"

const COLORS = [
  "#8884d8", "#82ca9d", "#FFBB28", "#FF8042", "#AF19FF"
]

const DemandPieChart = ({ trends, scoreKey, unitsToSell, setShowImagesPopup, chartLabel }) => {
  const [displayTrends, setDisplayTrends] = useState([])
  const [scoreSum, setScoreSum] = useState(1)

  useEffect(() => {
    const temp = []
    trends.forEach(trend => {
      const tempTrend = { ...trend }
      tempTrend.unitsToSell = parseInt(trend[scoreKey] * unitsToSell / scoreSum)
      tempTrend.pieChartLabel = `${trend.value} (${trend.tag})`
      tempTrend.trendTag = `${trend.tag}`
      tempTrend.trendValue = `${trend.value}`
      temp.push(tempTrend)
    })
    setDisplayTrends(temp)
  }, [trends, scoreSum])

  useEffect(() => {
    const newScoreSum = trends.reduce((prev, current) => {
      return prev + current[scoreKey]
    }, 0)
    setScoreSum(newScoreSum)
  }, [trends, scoreKey])

  const onClickHandler = (trend) => {
    if (trend && trend._id) {
      const value = trend._id.split('__').pop()

      setShowImagesPopup({ ...trend, value })
    }
  };


  return <div className="w-1/3 h-[30rem] border-b">
    <div className="w-full h-[90%] ">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={'100%'} height={'100%'} >
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
          <Pie
            data={displayTrends}
            dataKey="unitsToSell"
            outerRadius={160}
            cx="50%"
            cy="50%"
            onClick={onClickHandler}
          >
            {displayTrends.map((trend, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
    <p className="text-center font-semibold ">{chartLabel}</p>

  </div>
}

export default DemandPieChart
